module.exports = __webpack_public_path__ + "img/O2O-pic1-01.55c072bc.png";